import { useTitlesApi } from '@api/hooks/useTitlesApi';
import useLoad, { LoadOptions } from '@hooks/useLoad';
import useSubscriber from '@hooks/useSubscriber';
import { useIsNewIngest } from '@hooks/useTitlesDataSource';
import { DetailedTitle, TTitleContext } from '@models/Title';
import { ExtendedTitleContext } from '@store/titles/types';

const useTitleQuery = (
  titleContext: Partial<TTitleContext>,
  options: LoadOptions<DetailedTitle> | undefined = { refetchOnDisableCache: true },
  viewAsSubscriber?: boolean
) => {
  const isNewIngest = useIsNewIngest();
  const { getTitle } = useTitlesApi();
  const { subscriber } = useSubscriber();
  const subscriberId = viewAsSubscriber ? subscriber?.subscriberId : undefined;

  const extendedTitleContext = { ...titleContext, subscriberId };

  return useLoad(
    () => getTitle(extendedTitleContext as ExtendedTitleContext),
    [
      'title',
      extendedTitleContext,
      ...(subscriberId ? [subscriberId] : []),
      ...(isNewIngest ? ['new-ingest'] : []),
    ],
    {
      ...options,
      enabled:
        Boolean(extendedTitleContext.masterId || extendedTitleContext.platformTitleId) &&
        options?.enabled !== false,
      staleTime: Infinity,
    }
  );
};

export default useTitleQuery;
